/**
 * Scroll to top of page smoothly and focus on alert element for accessibility
 * Useful for displaying validation banners and error messages
 */
export const scrollToTopAndFocusAlert = (delay: number = 350): void => {
  try {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setTimeout(() => {
      const el = document.querySelector<HTMLElement>('[role="alert"]')
      if (el) {
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1')
        el.focus()
      }
    }, delay)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.debug('scroll to top and focus alert failed', e)
  }
}
